import React, { useState, useEffect, useRef } from "react";

const INITIAL_GRID = [
  [1, 2, 3],
  [4, 5, 6],
  [7, 8, 0], // 0 = case vide
];

const DEFAULT_LABELS = {
  1: "LE REGISTRE",
  2: "DES EMPLOYÉS",
  3: "ET DE LEURS ID",
  4: "NE DOIT PLUS ",
  5: "TRAINER SUR LA TABLE,",
  6: "EN SALLE DE REUNION.",
  7: "NE LAISSER",
  8: "AUCUNE COPIE AILLEURS",
  0: "",
};

const LABELS_6J = {
  1: "LE REGISTRE",
  2: "EST BIEN DANS",
  3: "LE BUREAU RH,",
  4: "SOUS CLÉ.",
  5: "NE LAISSER",
  6: "AUCUNE",
  7: "COPIE",
  8: "AILLEURS.",
  0: "",
};

// Shuffle simple jusqu'à obtenir une config solvable
function shuffleToSolvable(baseGrid) {
  const flat = baseGrid.flat();
  let arr;
  do {
    arr = [...flat];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
  } while (!isSolvable(arr));
  return [
    arr.slice(0, 3),
    arr.slice(3, 6),
    arr.slice(6, 9),
  ];
}

function isSolvable(arr) {
  const withoutZero = arr.filter((n) => n !== 0);
  let inv = 0;
  for (let i = 0; i < withoutZero.length; i++) {
    for (let j = i + 1; j < withoutZero.length; j++) {
      if (withoutZero[j] < withoutZero[i]) inv++;
    }
  }
  return inv % 2 === 0;
}

function findEmptyNeighbour(grid, x, y) {
  const dirs = [
    { dx: -1, dy: 0 },
    { dx: 1, dy: 0 },
    { dx: 0, dy: -1 },
    { dx: 0, dy: 1 },
  ];
  for (const { dx, dy } of dirs) {
    const nx = x + dx;
    const ny = y + dy;
    if (nx < 0 || nx > 2 || ny < 0 || ny > 2) continue;
    if (grid[nx][ny] === 0) return { x: nx, y: ny };
  }
  return null;
}

export function RhRegisterTaquin({
  onSolved,
  solvedStatic,
  initialMoves = 0,
  onMovesChange,
  /** Optionnel — passer LABELS_6J pour la variante 6 joueurs */
  labels,
}) {
  const LABELS = labels || DEFAULT_LABELS;

  const [grid, setGrid] = React.useState(() =>
    solvedStatic ? INITIAL_GRID : shuffleToSolvable(INITIAL_GRID)
  );
  const [solved, setSolved] = React.useState(!!solvedStatic);

  const movesRef = React.useRef(0);
  const [moves, setMoves] = React.useState(0);

  useEffect(() => {
    movesRef.current = initialMoves;
    setMoves(initialMoves);
    onMovesChange?.(initialMoves);
  }, [initialMoves, onMovesChange]);

  const handleClickCell = (x, y) => {
    if (solved) return;

    const emptyPos = findEmptyNeighbour(grid, x, y);
    if (!emptyPos) return;

    const newGrid = grid.map((row) => [...row]);
    const tmp = newGrid[x][y];
    newGrid[x][y] = 0;
    newGrid[emptyPos.x][emptyPos.y] = tmp;

    movesRef.current += 1;
    setMoves(movesRef.current);
    onMovesChange?.(movesRef.current);

    setGrid(newGrid);

    const ok = newGrid.flat().every((v, i) => v === INITIAL_GRID.flat()[i]);
    if (ok) {
      setSolved(true);
      onSolved?.(movesRef.current);
    }
  };

  return (
    <div className="inline-block bg-slate-800/60 p-2 rounded-lg border border-white/15">
      {grid.map((row, i) => (
        <div key={i} className="flex">
          {row.map((val, j) => {
            const isEmpty = val === 0;
            return (
              <button
                key={`${i}-${j}`}
                type="button"
                onClick={() => handleClickCell(i, j)}
                className={[
                  "w-20 h-20 m-1 rounded-md flex items-center justify-center text-[9px] text-center px-1",
                  isEmpty
                    ? "bg-transparent cursor-default"
                    : "bg-slate-900/80 text-amber-100 border border-white/10 hover:bg-slate-700/80",
                ].join(" ")}
              >
                {!isEmpty && (
                  <span className="font-semibold">
                    {solved ? LABELS[val] : val}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      ))}

      {!solved ? (
        <>
          <p className="mt-2 text-[10px] text-gray-400 text-center max-w-xs">
            Réorganise les morceaux de la note en laissant la case 9 vide.
          </p>
          <p className="mt-1 text-[10px] text-slate-300 text-center">
            Coups : <span className="font-bold text-amber-200">{moves}</span>
          </p>
        </>
      ) : (
        <p className="mt-2 text-[10px] text-emerald-200 text-center">
          ✅ Résolu en <span className="font-bold">{moves}</span> coups
        </p>
      )}
    </div>
  );
}

// Export des labels pour usage dans les composants parents
export { DEFAULT_LABELS as TAQUIN_LABELS_DEFAULT, LABELS_6J as TAQUIN_LABELS_6J };